/**
 * useSegment — resolve the tenant's industry segment for entity labelling.
 *
 * Reads companies/{cid}/settings/segment once (the same path
 * companySettingsService writes) and defaults to 'general' on miss or error.
 * Pair with segmentService.resolveJobLabel to get 'Project' vs 'Job'.
 *
 * Extracted from AdminLayout 2026-08-30 so the rail, the Projects sub-nav and
 * any other label-aware surface all read the segment the same way.
 */

import { useState, useEffect } from 'react';
import { ref, get } from 'firebase/database';
import { useAuth } from '../contexts/AuthContext';
import { getDatabaseInstance } from '../services/recruiterApi';

export default function useSegment() {
  const { user } = useAuth();
  const companyId = user?.companyId;
  const [segment, setSegment] = useState('general');

  useEffect(() => {
    if (!companyId) return undefined;
    let cancelled = false;
    get(ref(getDatabaseInstance(), `companies/${companyId}/settings/segment`))
      .then((snap) => {
        if (!cancelled && snap.exists() && typeof snap.val() === 'string') {
          setSegment(snap.val());
        }
      })
      .catch(() => { /* keep default 'general' on read failure */ });
    return () => { cancelled = true; };
  }, [companyId]);

  return segment;
}
